<template>
  <div class="container" id="HONOR">
    <div class="common-title">
      <div class="common-title-content">
        公司荣誉
      </div>
    </div>
    <div class="swiper-main">
      <swiper class="content" :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="(item, index) in swipers" :key="index">
          <div class="swiper-item-content">
            <div class="swiper-item-slide">
              <img :src="item.imgSrc" alt="" />
            </div>
          </div>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: "honor",
  data() {
    return {
      swipers: [
        { imgSrc: require("@/assets/images/certificate/专利1.png") },
        { imgSrc: require("@/assets/images/certificate/专利2.png") },
        {
          imgSrc: require("@/assets/images/certificate/《传输承载网格系统》物联网（智慧平安小区）平台V1.0.png")
        },
        {
          imgSrc: require("@/assets/images/certificate/全景智联城市安全应急指挥调度平台.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/全景智联大数据平台 V1.0.png")
        },
        {
          imgSrc: require("@/assets/images/certificate/全景智联机场大数据分析应用平台.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/全景智联机场智慧调度平台.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/全景智联机场智慧运营管理平台.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/全景智联智慧制造ERP系统.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/全景智联智慧制造商家服务系统.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/全景智联中台服务流程控制与管理服务系统.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/全景智联中台服务身份认证管理服务系统.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/社会综治-“屋畔”社区服务APP软件（ios版）V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/社会综治-“屋畔”社区服务APP软件（安卓版）V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/社会综治-数据中台软件V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/社会综治-物联网智慧平安小区管理平台V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/社会综治-移动警务助手软件（安卓版）V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/社会综治-综合业务管理平台V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/社会综治-综合业务中台软件V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/物联网智慧平安小区运营管理平台［简称：运营管理平台］V1.0.png")
        },
        {
          imgSrc: require("@/assets/images/certificate/智慧警务-“屋畔”社区服务APP软件（ios版）V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/智慧警务-“屋畔”社区服务APP软件（安卓版）V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/智慧警务-数据中台软件V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/智慧警务-物联网智慧平安小区管理平台V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/智慧警务-移动警务助手软件（安卓版）V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/智慧警务-综合业务管理平台V2.0.jpg")
        },
        {
          imgSrc: require("@/assets/images/certificate/智慧警务-综合业务中台软件V2.0.jpg")
        },
        { imgSrc: require("@/assets/images/certificate/ISO9001证书中文.png") },
        { imgSrc: require("@/assets/images/certificate/产品质量认证证书.png") },
        { imgSrc: require("@/assets/images/certificate/大数据企业证书.png") },
        { imgSrc: require("@/assets/images/certificate/cmmi中文.png") },
        {
          imgSrc: require("@/assets/images/certificate/金钥匙优胜奖-北京全景.png")
        },
        { imgSrc: require("@/assets/images/certificate/企业信用等级证书.png") },
        {
          imgSrc: require("@/assets/images/certificate/软件企业证书1-2021.png")
        }
      ],
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        loop: true,
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 30,
        loopFillGroupWithBlank: true,
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        autoplay: {
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mouted() {
    this.swiper.el.onmouseover = function() {
      this.swiper.autoplay.stop();
    };
    this.swiper.el.onmouseout = function() {
      this.swiper.autoplay.stop();
    };
  }
};
</script>

<style lang="less" scoped>
.swiper-container {
  padding-bottom: 2rem;
}
.swiper-container .swiper-wrapper .swiper-slide {
  width: 43.4rem;
  height: 25rem;
}
.swiper-pagination {
  bottom: 0 !important;
}
.swiper-pagination-bullet {
  width: 2.38rem;
  height: 0.31rem;
  border-radius: 1px;
  background-color: #a2a2a2;
}
.swiper-pagination-bullet-active {
  background-color: #fff;
}
.swiper-main {
  width: 73rem;
  margin: 0 auto 3.5rem;
}
.swiper-item-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .swiper-item-slide {
    position: relative;
    display: flex;
    align-items: center;
    img {
      width: 100%;
    }
  }
}
</style>
